<div class="preloader" 
  [ngClass]="{
  'loading': loadingScreenService.loading()
}"><div class="loader"></div></div>
